module.exports = __webpack_public_path__ + "static/media/logo.b87093cd.jpg";